import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom';
import { queryOptions, useQuery, useQueryClient } from '@tanstack/react-query';
import { loading, queryClient as qc } from 'keys';
import { initialPage } from 'keys/pagination';
import { getAssessmentAbilitiesFetch, getAssessmentProfilesFetch, getAssessmentReportFetch, getAssessmentSummaryByTestTakerFetch, getBarChartData, getBatteriesFetch, getBatteryFetch, getDoughnutChartsFetch, getProsodyDoughnutChart } from 'store/middlewares/assessment.crud';
import { useSelector } from 'react-redux';
import { getReportModel } from 'keys/ordering';
import { Title as ScreenTitle } from 'components'
import IconTabs from 'components/Tabs/IconTabs';
import { WrapViewTypes } from './Style'
import { SmallSpace, Space } from 'styles/GlobalStyle';
import { NotificationAlert } from 'components/Form'
import { AssessmentTableTabs, BarCharts, DeleteAssessmentsAlert, AssignAssessmentAlert, CreateBatteryAlert, DoughnutCharts, UpdateStatusAlert, AssignAssessmentAlert2, DuplicateAndAssignAlert, assessmentsHooks, UpdateMissedAlert, UpdateExecutionAlert } from '.';
import { isEmpty, keyBy } from 'lodash';
import { useDispatch } from 'react-redux';
import { actions } from 'store';
import { AssessmentsStyles } from './Style'
import { secretStorage } from 'config';
import { statusOptions } from 'keys/statuses';
import { getCurrentSchoolYear, getCurrentSemesterAndYear } from 'utils/general';
import { Profiles } from 'pages';
import Assessments from './Assessments'

export const viewTypes = { table: "table", chart: "chart", profile: "profile", bar: "bar", profile2: "profile2", readingGroups: "readingGroups", generalSummary: "generalSummary" }
export const batteryViewTypes = { circle: "circle", details: "details" }
export const tableViewTypes = { battery: "battery", single: "single" }

export const initialTableView = tableViewTypes.battery
export const initialProfileTab = 0

export const batteryStatusOptions = [{ id: "CREATED", name: "לא הופק" }, { id: "IN_PROGRESS", name: "חלקי" }, { id: "COMPLETE", name: "מלא" }]

const WarpAssessmentsContext = (props) => {
    const dispatch = useDispatch()
    const location = useLocation()
    const queryClient = useQueryClient()

    const isSuperuser = secretStorage.getItem("user")?.is_superuser

    const { headerFilters } = useSelector(state => state.header)
    const { testTaker } = useSelector(state => state.testTaker)
    const { updateAssessmentScreenViewFlag, assessmentScreenView } = useSelector(state => state.assessment)

    const [ownAssessmentFilters, setOwnAssessmentFilters] = useState({
        status: [keyBy(statusOptions, "status").completed],
        battery_status: batteryStatusOptions[3]
    })
    // סמסטר/שנה משותפים לכל תצוגות הדוחות (טבלה, חלוקה לדירוגים, חלוקה לתחומי בדיקה, קבוצות קריאה),
    // כדי שהבחירה תישאר אחידה ולא תתאפס במעבר בין הטאבים
    const [profileFilters, setProfileFilters] = useState(() => {
        const { semester, school_year } = getCurrentSemesterAndYear()
        return { semester, school_year }
    })

    const assessmentFilters = useMemo(() => ({
        ...ownAssessmentFilters,
        semester: profileFilters.semester,
        school_year: profileFilters.school_year
    }), [ownAssessmentFilters, profileFilters])

    const setAssessmentFilters = useCallback((newFilters) => {
        const { semester, school_year, ...rest } = newFilters
        setProfileFilters(prev => ({
            semester: semester !== undefined ? semester : prev.semester,
            school_year: school_year !== undefined ? school_year : prev.school_year
        }))
        setOwnAssessmentFilters(rest)
    }, [])
    const [profileAcordions, setProfileAcordions] = useState([])
    const [abilityAcordions, setAbilityAcordions] = useState([])
    const [openReport, setOpenReport] = useState(false)
    const [pageSize, setPageSize] = useState(15)
    const [viewCell, setViewCell] = useState({
        ["calculations.words_per_minute"]: "label",
        ["calculations.percent_accuracy"]: "label",
        ["calculations.fluency_reading"]: "label",
        ["calculations.factored_percent_accuracy"]: "label",
        ["calculations.words_correct_per_minute"]: "label",
        prosody: "label"
    })
    const [page, setPage] = useState(initialPage)
    const [batteryPage, setBatteryPage] = useState(initialPage)

    const [sorting, setSorting] = useState([])
    const [searchVal, setSearchVal] = useState("")
    const [viewScreen, setViewScreen] = useState(location?.state?.view || viewTypes.profile)
    const [selectedProfileTab, setSelectedProfileTab] = useState(initialProfileTab)
    const [selectedAssessments, setSelectedAssessments] = useState(null)
    const [resetRowSelection, setResetRowSelection] = useState(false)
    const [viewReportId, setViewReportId] = useState(null)
    const [performBatteryCellView, setPerformBatteryCellView] = useState(batteryViewTypes.circle)
    const [openRowIndex, setOpenRowIndex] = useState(null);
    const [rowOpen, setRowOpen] = useState(null);
    const [tableView, setTableView] = useState(initialTableView);
    const [showQuestionAssessments, setShowQuestionAssessments] = useState(false)

    const [openMissedAlert, setOpenMissedAlert] = useState(null)
    // null / "cancel" / "restore" 
    const [openExecutionAlert, setOpenExecutionAlert] = useState(null)
    const [openDuplicateAlert, setOpenDuplicateAlert] = useState(null)
    const [openCreateBatteryAlert, setOpenCreateBatteryAlert] = useState(null)
    const [openStatusAlert, setOpenStatusAlert] = useState(null)
    const [isAssignAssessmentAlertOpen, setIsAssignAssessmentAlertOpen] = useState(null)
    const [isAssignAssessmentAlert2Open, setIsAssignAssessmentAlert2Open] = useState(null)
    const [deleteAssessmentsAlertOpen, setDeleteAssessmentsAlertOpen] = useState(null)
    const [showActionBtns, setShowActionBtns] = useState(false)

    const batteryDefs = queryClient.getQueryData([qc.batteries])
    const model = getReportModel(viewCell)

    const viewTypeBtns = assessmentsHooks.useViewTypesHeaderBtns()

    // שליפה של מבדקים מבודדים
    const assessmentOptions = queryOptions({
        queryKey: [
            qc.report, page, pageSize, sorting, headerFilters, testTaker, searchVal, showQuestionAssessments, assessmentFilters,
            tableView != tableViewTypes.battery
        ],
        queryFn: async ({ signal }) => {
            const { data } = await getAssessmentReportFetch({ assessmentFilters, headerFilters, testTaker, signal, page, pageSize, sorting, search: searchVal, customModel: model, showQuestions: showQuestionAssessments })
            return data
        },
        enabled: viewScreen === viewTypes.table && tableView == tableViewTypes.single && !viewReportId,
        refetchOnMount: true,
        refetchOnWindowFocus: true
    })

    // שליפה של מבדקים מקובצים לפי סוללות
    const batteryOptions = queryOptions({
        queryKey: [
            qc.studentBatteries, batteryPage, pageSize, sorting, headerFilters, testTaker, searchVal, assessmentFilters,
            tableView == tableViewTypes.battery
        ],
        queryFn: async ({ signal }) => {
            const { data } = await getBatteryFetch({ assessmentFilters, headerFilters, testTaker, signal, page: batteryPage, pageSize, sorting, search: searchVal, model: qc.studentBatteries })
            return data
        },
        enabled: viewScreen === viewTypes.table && tableView == tableViewTypes.battery,
    })

    const profileOptions = queryOptions({
        queryKey: [qc.profiles, headerFilters, testTaker, selectedProfileTab, assessmentFilters],
        queryFn: async () => {
            const { data } = await getAssessmentProfilesFetch({ isSuperuser, assessmentFilters, headerFilters, testTaker })
            setProfileAcordions(new Array(9).fill(false))
            return data
        },
        refetchOnMount: false,
        enabled: false
    })

    const abilitiesOptions = queryOptions({
        queryKey: [qc.abilities, headerFilters, testTaker, selectedProfileTab, assessmentFilters],
        queryFn: async () => {
            const { data } = await getAssessmentAbilitiesFetch({ isSuperuser, assessmentFilters, headerFilters, testTaker })
            setAbilityAcordions(new Array(9).fill(false))
            return data
        },
        enabled: false
    })

    const doughnutChartOptions = queryOptions({
        queryKey: [
            qc.doughnutCharts, headerFilters, testTaker, assessmentFilters],
        queryFn: async ({ signal }) => {
            const { data } = await getDoughnutChartsFetch({ isSuperuser, assessmentFilters, headerFilters, testTaker, signal })
            return data
        },
        enabled: viewScreen == viewTypes.chart
    })

    const prosodyDoughnutOptions = queryOptions({
        queryKey: [qc.prosodyDoughnut, headerFilters, testTaker, assessmentFilters],
        queryFn: async ({ signal }) => {
            const { data } = await getProsodyDoughnutChart({ assessmentFilters, headerFilters, testTaker, signal })
            return data
        },
        enabled: viewScreen == viewTypes.chart
    })

    const assessmentCount = useQuery({
        queryKey: [qc.assessmentCount, headerFilters, testTaker, selectedProfileTab, assessmentFilters],
        queryFn: async () => {
            const { data } = await getAssessmentSummaryByTestTakerFetch({ assessmentFilters, headerFilters, testTaker })
            return data
        },
        refetchOnMount: false
    })

    const correctWordsPerMinuteBarChart = useQuery({
        queryKey: [qc.correctWordsPerMinuteBar, assessmentFilters.test_type, assessmentFilters],
        queryFn: async () => {
            const { data } = await getBarChartData({ assessmentFilters, headerFilters, testTaker, testType: assessmentFilters.test_type.id })
            return data
        },
        enabled: viewScreen == viewTypes.bar
    })

    const profiles = useQuery(profileOptions)
    const abilities = useQuery(abilitiesOptions)
    const batteries = useQuery(batteryOptions)
    const assessments = useQuery(assessmentOptions)
    const doughnutCharts = useQuery(doughnutChartOptions)
    const prosodyDoughnuts = useQuery(prosodyDoughnutOptions)

    const refetchTableData = useCallback(async () => {
        setPage(initialPage)
        setBatteryPage(initialPage)
        assessments.remove?.()
        assessments.refetch()
    }, [])

    const refetchBatteryData = useCallback(async () => {
        setPage(initialPage)
        setRowOpen(null)
        setBatteryPage(initialPage)
        batteries.remove?.()
        batteries.refetch()
    }, [])

    const refetchChartData = useCallback(async () => {
        doughnutCharts.refetch()
        prosodyDoughnuts.refetch()
    }, [headerFilters, testTaker])

    const refetchBarChartData = useCallback(async () => {
        correctWordsPerMinuteBarChart.refetch()
    }, [])

    const refetchProfileData = useCallback(async () => {
        profiles.refetch()
    }, [])

    const refetchAbilityData = useCallback(async () => {
        abilities.refetch()
    }, [])

    useEffect(() => {
        // queryClient.resetQueries([qc.abilities, qc.profiles])
    }, [assessmentFilters.category])

    useEffect(() => {
        return () => {
            dispatch(actions.setAssessmentScreenView(viewScreen))
        }
    }, [viewScreen])

    useEffect(() => {
        if (updateAssessmentScreenViewFlag && assessmentScreenView) {
            setViewScreen(assessmentScreenView)
            dispatch(actions.setAssessmentScreenView(null))
            dispatch(actions.setUpdateAssessmentScreenViewFlag(false))
        }
    }, [updateAssessmentScreenViewFlag])

    const disabledProfileQuery = isEmpty(assessmentFilters.category)
    const disabledBarQuery = isEmpty(assessmentFilters.category) || isEmpty(assessmentFilters.test_type)

    const viewTypeBtnKeys = keyBy(viewTypeBtns, "type")
    const screenTypeItem = viewTypeBtnKeys?.[viewScreen]

    const changeViewType = useCallback(({ type }) => {
        setViewScreen(type)
        // const newItem = viewTypeBtnKeys[type]
        // if (newItem.disabledQuery) return
        // newItem?.refetch()
    }, [assessmentFilters, disabledProfileQuery, disabledBarQuery])


    const commonState = {
        viewCell, setViewCell,
        assessments,
        initialTableView,
        batteries,
        viewTypes,
        page, setPage,
        openCreateBatteryAlert, setOpenCreateBatteryAlert,
        batteryPage, setBatteryPage,
        sorting, setSorting,
        openMissedAlert, setOpenMissedAlert,
        setOpenExecutionAlert,
        searchVal, setSearchVal,
        selectedAssessments, setSelectedAssessments,
        assessmentOptions,
        batteryOptions,
        disabledProfileQuery,
        disabledBarQuery,
        viewScreen,
        setShowQuestionAssessments,
        batteryDefs,
        resetRowSelection, setResetRowSelection,
        assessmentFilters, setAssessmentFilters,
        profileFilters, setProfileFilters,
        deleteAssessmentsAlertOpen, setDeleteAssessmentsAlertOpen,
        viewReportId, setViewReportId,
        refetchTableData,
        refetchChartData,
        pageSize, setPageSize,
        screenTypeItem,
        rowOpen, setRowOpen,
        openRowIndex, setOpenRowIndex,
        profileAcordions, setProfileAcordions,
        selectedProfileTab, setSelectedProfileTab,
        profiles,
        correctWordsPerMinuteBarChart,
        abilities,
        doughnutCharts,
        initialProfileTab,
        abilitiesOptions,
        assessmentCount,
        openDuplicateAlert, setOpenDuplicateAlert,
        openReport, setOpenReport,
        performBatteryCellView, setPerformBatteryCellView,
        isAssignAssessmentAlert2Open, setIsAssignAssessmentAlert2Open,
        tableView, setTableView,
        setOpenStatusAlert,
        showActionBtns, setShowActionBtns,
        isBatteryTab: tableView != tableViewTypes.single,
        isAssignAssessmentAlertOpen, setIsAssignAssessmentAlertOpen,
        loading: assessments.isFetching || batteries.isFetching || profiles.isFetching || abilities.isFetching || correctWordsPerMinuteBarChart.isFetching,
        //  || batteries.loading || profiles.loading || abilities.loading || correctWordsPerMinuteBarChart.loading
    }

    return (
        <AssessmentsContext.Provider value={commonState}>
            <ScreenTitle
                {...props}
                breadcrumbs={false}
            >{null}</ScreenTitle>
            <WrapViewTypes>
                <IconTabs
                    tabs={viewTypeBtns.map(({ label, icon, tooltip, disabled }) => ({ label, icon, tooltip, disabled }))}
                    value={viewTypeBtns.findIndex(btn => btn.type === viewScreen)}
                    handleTab={(index) => changeViewType(viewTypeBtns[index])}
                />
            </WrapViewTypes>
            <AssessmentsStyles>
                <Assessments {...props} />
            </AssessmentsStyles>
            {openCreateBatteryAlert &&
                <CreateBatteryAlert handleAlert={() => {
                    setOpenCreateBatteryAlert()
                    setResetRowSelection(false)
                }} />}
            {openStatusAlert &&
                <UpdateStatusAlert handleAlert={() => {
                    setOpenStatusAlert()
                    setResetRowSelection(false)
                }} />}
            {isAssignAssessmentAlertOpen &&
                <AssignAssessmentAlert handleAlert={() => {
                    setIsAssignAssessmentAlertOpen()
                    setResetRowSelection(false)
                }} />}
            {isAssignAssessmentAlert2Open &&
                <AssignAssessmentAlert2 handleAlert={() => {
                    setIsAssignAssessmentAlert2Open()
                    setResetRowSelection(false)
                }} />}
            {deleteAssessmentsAlertOpen &&
                <DeleteAssessmentsAlert handleAlert={() => {
                    setDeleteAssessmentsAlertOpen()
                    setResetRowSelection(false)
                }} />}
            {openDuplicateAlert &&
                <DuplicateAndAssignAlert handleAlert={() => {
                    setOpenDuplicateAlert()
                    setResetRowSelection(false)
                }} />}
            {openMissedAlert &&
                <UpdateMissedAlert handleAlert={() => {
                    setOpenMissedAlert()
                    setResetRowSelection(false)
                }} />}
            {openExecutionAlert &&
                <UpdateExecutionAlert cancel={openExecutionAlert === "cancel"} handleAlert={() => {
                    setOpenExecutionAlert()
                    setResetRowSelection(false)
                }} />}
            <NotificationAlert
                title={"חשוב לדעת!"}
                description={"דירוג ביצועי הילדים מבוסס על נתונים מצטברים. התוצאות עשויות להשתנות ככל שיתווספו נתוני ביצועים של ילדים בכיתות הטרוגניות מהחינוך הרגיל."}
                storageKey="reports-message-approved"
                actionLabel={"הבנתי"}
            />
        </AssessmentsContext.Provider>
    )
}

export const AssessmentsContext = React.createContext()
export default WarpAssessmentsContext